
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    currentId: {
      required: true
    }
  },

  methods: {
    handleClick: function handleClick(id) {
      if (this.currentId === id) return;
      this.$emit('change', id);
    }
  },

  computed: {}
};